module.exports = __webpack_public_path__ + "img/492.b98e2a94.gif";